import { useCallback, useMemo, useRef, useState } from 'react';

import ContextMenu from './ContextMenu';
import ContextMenuContext from './ContextMenu.context';
import type {
  ContextMenuItem,
  ContextMenuProviderProps,
  ContextMenuRefType
} from './ContextMenu.types';

export { ContextMenuContext };

export const ContextMenuProvider = ({
  children,
  anchorOrigin,
  transformOrigin,
  menuItems: initialMenuItems,
  clickHandler
}: ContextMenuProviderProps) => {
  const childRef = useRef<ContextMenuRefType>(null);
  const [selectedItem, setSelectedItem] = useState('');
  const [menuItems, setMenuItems] =
    useState<ContextMenuItem[]>(initialMenuItems);

  const showContextMenu = useCallback(
    (e: React.MouseEvent, item?: string, newMenuItems?: ContextMenuItem[]) => {
      e.stopPropagation();
      setSelectedItem(item as string);
      if (newMenuItems) {
        setMenuItems(newMenuItems);
        childRef.current?.showContextMenu(
          e.target as HTMLElement,
          newMenuItems
        );
      } else {
        childRef.current?.showContextMenu(e.target as HTMLElement);
      }
    },
    []
  );

  const value = useMemo(
    () => ({ menuItems, showContextMenu, setMenuItems }),
    [menuItems]
  );

  const handleClick = (param: string) => {
    if (param !== '' && clickHandler) {
      clickHandler(param, selectedItem);
    }
  };

  return (
    <ContextMenuContext.Provider value={value}>
      {children}
      <ContextMenu
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        ref={childRef}
        menuList={menuItems}
        clickHandler={handleClick}
      />
    </ContextMenuContext.Provider>
  );
};

export default ContextMenuProvider;
